import { obtenerCatalogo } from "../listas/obtenerCatalogo";

/**
 * Método que retorna el nombre del municipio 
 * @param {Number} idMunicipio 
 * @returns String del municipio
 */
export const obtenerNombreMunicipio = async idMunicipio => {
    let nombreMunicipio = String();
    try {
        const lista = await obtenerCatalogo("/api/municipio/lista", "Imposible obtener catálogo: Municipios");
        for (let i = 0; i < lista.length; i++) {
            if (Number(lista[i].idMunicipio) === Number(idMunicipio)) {
                nombreMunicipio = lista[i].nombre;
                break;
            }
        }
        return nombreMunicipio;
    }
    catch (error) {
        return nombreMunicipio;
    }
}